<template>
  <div class="flex flex-col items-start prodbox">

    <NuxtLink class="w-full prodimage" v-if="modelValue" :to="`/products/${modelValue.handle}`" @click="handleSelect">
      <UiProductImage v-if="modelValue.featuredImage" :url="modelValue.featuredImage.url"
        :title="modelValue.featuredImage.altText ?? modelValue.title" fit="crop"
        :sizes="'sm:100vw md:600px lg:25vw xl:25vw'">

        <LogoDtSwiss v-if="productHasTag('DT Swiss')" />
        <LogoReserve v-if="productHasTag('Reserve')" />

      </UiProductImage>
    </NuxtLink>
    <p class="mt-5 pb-1 uppercase mb-0 text-gravaadarkbrown text-sm">{{ modelValue.productType }}</p>

    <div v-if="modelValue" class="flex flex-col">
      <NuxtLink class="mb-0" :to="`/products/${modelValue.handle}`" @click="handleSelect">
        <h3 class="mb-1">{{ modelValue.title }}</h3>
        <p v-if="modelValue.shortDescription" class="mb-1 text-sm">{{ modelValue.shortDescription?.value }}</p>
        <div class="flex gap-6 items-center">
          <UiPrice :amount="modelValue.priceRange.minVariantPrice.amount.toString()" />
          <div v-if="(modelValue.productType || '').toLowerCase().includes('wheelset')"
            class="text-xs text-gravaablack opacity-50">
            Inlcuding the Gravaa System
          </div>
        </div>
        <UiRippleButton class="lightbrown mt-12">
          View Details
        </UiRippleButton>
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { ProductModel } from "~/types/shopify";
import { mapProductToGa4Item } from '@/utils/ga4Map'

const props = defineProps<{
  modelValue: ProductModel
}>();

const gtmProxy = process.client ? useScriptGoogleTagManager()?.proxy : null;

const productHasTag = (tag: string) => {
  try {
    return props.modelValue.tags.includes(tag);
  } catch (e) {
    return false;
  }
};

const numberOfVariationsAvailableForPurchase = computed(() => {
  try {
    return props.modelValue.variants.edges.filter((variant: { node: { availableForSale: boolean } }) => variant.node.availableForSale).length;
  } catch (e) {
    return 0;
  }
});

const handleSelect = () => {
  if (!process.client || !gtmProxy) return;

  try {
    const listId = window.location.pathname || '/shop';
    const listName = window.location.pathname || '/shop';

    const item = mapProductToGa4Item({
      product: props.modelValue,
      listId,
      listName
    });

    if (!item) return;

    const currency =
      props.modelValue?.priceRange?.minVariantPrice?.currencyCode ??
      props.modelValue?.variants?.edges?.[0]?.node?.price?.currencyCode ??
      'EUR';

    gtmProxy.dataLayer.push({
      event: 'select_item',
      ecommerce: {
        currency,
        items: [item]
      },
      pageUrl: window.location.href
    });
  } catch (err) {
    console.warn('Error while pushing select_item analytics', err);
  }
};

</script>

<style scoped>
@reference "../../assets/css/main.css";

h3 {
  @apply text-2xl mb-2 md:mb-2;
  font-variation-settings: 'wght' 420, 'wdth' 100, 'slnt' 0;
}

a.prodimage {
  @apply bg-gravaalightwarmgray;
  transition: background-color 0.6s;
}

.prodbox:hover a.prodimage {
  @apply bg-gravaawarmgray;
}

a img {
  @apply scale-90 transition-transform duration-300;

}

.prodbox:hover a img {

  @apply scale-100;
}


@media (max-width: 640px) {
  h4 {
    @apply text-xl;
    /* Smaller size for xs screens */
  }
}
</style>